import React from 'react';
import { Navigate } from 'react-router-dom';

const ContributeScreen = () => <Navigate to="/" replace />;

export default ContributeScreen;
